// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "955d4cc7027c509f3deff469d8d1a3f15fa18f07/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};